export default "__VITE_ASSET__TQoAwPdq__"